import { useRouter } from 'next/router';
import { useQuery, useQueryClient, useIsFetching } from '@tanstack/react-query';

// import { atom } from 'jotai';
import { useRestaurantsService, ShowRestaurant } from '@restworld/data-services';
import { QUERY_KEYS, useQueryClientState } from '@restworld/utils-common';

// export const employerRestaurantDetailsAtom = atom<ShowRestaurant | null>(null);
export function useEmployerRestaurantDetailsQuery() {
  const restaurantsService = useRestaurantsService();
  const queryKey = useEmployerRestaurantDetailsQueryKey();
  const slug = useRouter().query.slug as string;
  const isPublicRoute = useRouter().asPath.startsWith('/p/venues');
  const query = useQuery({
    queryKey,
    queryFn: async () =>
      isPublicRoute
        ? await (
            await restaurantsService.showPublicRestaurant(slug)
          ).data.restaurant
        : (await restaurantsService.showRestaurant(slug)).data?.restaurant,
    enabled: !!slug,
  });

  return { restaurantDetails: query.data, query };
}

export default useEmployerRestaurantDetailsQuery;

export const useEmployerRestaurantDetailsQueryKey = (slug?: string) => {
  const slugFinal = (useRouter().query.slug as string) || slug;
  return [QUERY_KEYS.RESTAURANTS.DETAILS, slugFinal];
};

export const useEmployerRestaurantDetails = (slug?: string) => {
  const slugFinal = (useRouter().query.slug as string) || slug;
  const queryClient = useQueryClient();
  const queryKey = useEmployerRestaurantDetailsQueryKey(slugFinal);
  const restaurantDetails: ShowRestaurant['restaurant'] = !slugFinal ? null : queryClient.getQueryData(queryKey);

  return restaurantDetails;
};

export const useEmployerRestaurantDetailsQueryState = () => {
  const queryKey = useEmployerRestaurantDetailsQueryKey();
  return useQueryClientState(queryKey);
};
export const useEmployerRestaurantDetailsLoading = () => {
  const queryState = useEmployerRestaurantDetailsQueryState();
  return queryState?.status === 'pending';
};
export const useRestaurantNotPublicFlag = (slug?: string) => {
  const restaurantDetails = useEmployerRestaurantDetails(slug);
  return restaurantDetails?.show_details === false;
};

export const useEmployerRestaurantDetailsFetching = () => {
  const restaurantDetailsQueryKey = useEmployerRestaurantDetailsQueryKey();

  const isFetching = useIsFetching({ queryKey: restaurantDetailsQueryKey });
  return isFetching > 0;
};
